module.exports = __webpack_public_path__ + "static/img/shu.ccc55df6.png";